/**
 * Tax – L'Tax project translations
 * Merges all tax sections + dac7 + 1099
 */

import reports from "./reports.js";
import settings from "./settings.js";
import vatRegistration from "./vatRegistration.js";
import vatReturns from "./vatReturns.js";
import salesTaxReturns from "./salesTaxReturns.js";
import createReturns from "./createReturns.js";
import declarationTransactionsModal from "./declarationTransactionsModal.js";
import transactions from "./transactions.js";
import threshold from "./threshold.js";
import vatPayment from "./vatPayment.js";
import clients from "./clients.js";
import dac7 from "./dac7.js";
import report1099 from "./1099.js";

export default {
  ...reports,
  ...settings,
  ...vatRegistration,
  ...vatReturns,
  ...salesTaxReturns,
  ...createReturns,
  ...declarationTransactionsModal,
  ...transactions,
  ...threshold,
  ...vatPayment,
  ...clients,
  dac7,
  report1099,
};
